<template>
    <div>
        <div style="width:10rem;height:1px;background:rgba(233,233,233,1);"></div>

        <div v-for="(item,index) in refuseReason" @click="radioChange(index)"  class="flex-start" style="position:relative;width:10rem;height:1.92rem;background:rgba(255,255,255,1);">

            <img v-show="selectedIndex==index" src="../../image/refuseReason/radio-selected.png" style="margin-left:0.4rem;width:0.5333333333333333rem;height:0.5333333333333333rem;"></img>
            <img v-show="selectedIndex!=index" src="../../image/refuseReason/radio-common.png" style="margin-left:0.4rem;width:0.5333333333333333rem;height:0.5333333333333333rem;"></img>

            <div style="">
                <div style="margin-left:0.25333333333333335rem;height:0.41333333333333333rem;line-height:0.41333333333333333rem;font-size:0.4266666666666667rem;font-family:PingFang SC;font-weight:500;color:rgba(51,51,51,1);">{{item.title}}</div>
                <div class="ellipsis-1" style="margin-left:0.26666666666666666rem;padding-top:0.25333333333333335rem;width:8.4rem;height:0.30666666666666664rem;line-height:0.30666666666666664rem;font-size:0.32rem;font-family:PingFang SC;font-weight:400;color:rgba(153,153,153,1);">{{item.content}}</div>
            </div>

            <div v-if="index<refuseReason.length-1" style="position:absolute;bottom:0rem;right:0rem;width:9.6rem;height:1px;background:rgba(233,233,233,1);"></div>
        </div>

        <div v-show="selectedIndex==refuseReason.length-1" class="flex-start" style="align-items:flex-start;width:10rem;height:3.3066666666666666rem;background:rgba(255,255,255,1);">
            <img src="../../image/refuseReason/required-orange.png" style="padding:0.41333333333333333rem 0.14666666666666667rem;width:0.10666666666666667rem;height:0.10666666666666667rem;"></img>
            <textarea id="reasonTextarea" :value="submitInfo.specificReasons" @input="submitInfo.specificReasons=$event.target.value" maxlength="-1" placeholder="请填写具体原因，如：客户打错电话，实际不需要救援。" style="padding:0.3333333333333333rem 0.32rem;box-sizing:border-box;width:9.2rem;height:2.8533333333333335rem;background:rgba(250,250,250,1);border:1px solid rgba(233,233,233,1);border-radius:0.13333333333333333rem;font-size:0.32rem;font-family:PingFang SC;font-weight:400;"></textarea>
        </div>


        <div @click="submit" style="margin:1.28rem 0.32rem 0rem;width:9.36rem;height:1.1733333333333333rem;line-height:1.1733333333333333rem;text-align:center;background:rgba(230,154,97,1);border-radius:0.5866666666666667rem;font-size:0.48rem;font-family:PingFang SC;font-weight:500;color:rgba(255,255,255,1);">保存</div>
    </div>
</template>

<script>
    import request from '@/utils/request'
    import {
        Toast
    } from 'vant';
    export default {
        name: "refuseReason",
        components: {
            [Toast.name]: Toast
        },
        data() {
            return {
                selectedIndex:-1,
                refuseReason:[],
                submitInfo:{
                    id: "",
                    invalidReason: "",
                    specificReasons: ""
                }
            }
        },
        created:function(){

            let refuseReason=this.$route.params.data;
            let id=this.$route.params.id;


            this.submitInfo.id=id;
            this.refuseReason=refuseReason;
        },
        methods: {

            radioChange(index){
                this.selectedIndex=index;

                let submitInfo=this.submitInfo;
                let refuseReason=this.refuseReason;

                if(index<refuseReason.length-1){
                    submitInfo.invalidReason=refuseReason[index].title;
                    submitInfo.specificReasons=refuseReason[index].content;
                }else{//最后一项是其他
                    submitInfo.invalidReason=refuseReason[index].title;
                    submitInfo.specificReasons="";
                }
                this.submitInfo=submitInfo;
            },
            submit(){
                let _this=this;
                let submitInfo=this.submitInfo;

                let selectedIndex=this.selectedIndex;
                if(selectedIndex==-1){
                    Toast('请选择其中一项再保存!');
                    return;
                }
                if(submitInfo.specificReasons==""){
                    Toast('需要注明具体原因!');
                    return;
                }

                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    overlay:true
                });

                request({
                    url: '/item/invalid',
                    method: 'PUT',
                    data:submitInfo
                }).then(res=>{
                    Toast.clear();
                    if(res.code=="200"){
                        this.$router.back(-1);
                    }else{
                        Toast(res.msg);
                    }
                });
            }
        }
    }
</script>

<style scoped>
    body{
        margin: 0px;
        padding: 0px;
    }

    #reasonTextarea::-webkit-input-placeholder{
        color:rgba(204,204,204,1);
    }

    .flex-center{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:center;
    }
    .flex-start{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:flex-start;
    }
    .flex-end{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:flex-end;
    }
    .flex-between{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:space-between;
    }
    .flex-around{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:space-around;
    }




    .ellipsis-1{
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .ellipsis-2{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
    .ellipsis-3{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
    }
</style>
